var MobileModeHint;
(function (MobileModeHint) {
  MobileModeHint["Mobile"] = "mobile";
  MobileModeHint["NotMobile"] = "notMobile";
})(MobileModeHint || (MobileModeHint = {}));
var MobileModeHint$1 = MobileModeHint;

export { MobileModeHint$1 as M };
//# sourceMappingURL=MobileModeHint-af8b89c1.js.map
